import { c as _c } from "react/compiler-runtime";
import { COMPANY_SUBSCRIPTIONS_QUERY_OPTIONS } from "@src/constants/subscription-constants";
import { activeSeatUsageSelector, sceneSeatUsageSelector } from "@store/sdb-company/sdb-company-selector";
import { fetchCompanySubscriptions } from "@store/sdb-company/sdb-company-slice-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";

/**
 * Returns a function that fetches the subscriptions of the workspace again, since the seats in use
 * that the constraints of the plan count (`ACTIVE_SEAT` and `SCENE_SEAT`) only change on the backend.
 * Call it after anything that gives, takes or frees a seat, like removing a member from the workspace.
 *
 * Does nothing when the plan counts no seats, so that workspaces without seats do not fetch the
 * subscriptions for nothing.
 */
export function useRefreshSeatUsage() {
  const $ = _c(4);
  const dispatch = useAppDispatch();
  const xgSeatUsage = useAppSelector(activeSeatUsageSelector);
  const sceneSeatUsage = useAppSelector(sceneSeatUsageSelector);
  let t0;
  if ($[0] !== dispatch || $[1] !== sceneSeatUsage || $[2] !== xgSeatUsage) {
    t0 = function refreshSeatUsage() {
      if (!xgSeatUsage && !sceneSeatUsage) {
        return;
      }
      dispatch(fetchCompanySubscriptions({
        queryOptions: COMPANY_SUBSCRIPTIONS_QUERY_OPTIONS
      }));
    };
    $[0] = dispatch;
    $[1] = sceneSeatUsage;
    $[2] = xgSeatUsage;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}